// extracted by mini-css-extract-plugin
module.exports = {"board":"App_board__3YRFr"};